{
  "400": {
    "forbidden": "Verboden",
    "forbidden_desc": "Je hebt geen toegang tot deze pagina. Neem contact op met de fleet manager.",
    "forbidden_note": "(Synchronisatie van rechten kan tot 30 minuten duren.)",
    "log_out": "Afmelden",
    "retry": "Opnieuw proberen"
  },
  "404": {
    "back_button": "Terug naar overzicht",
    "contact_support": "Support contacteren",
    "go_home": "Ga naar de homepage",
    "not_found": "Pagina niet gevonden",
    "not_found_description": "De pagina die je zoekt, is mogelijks verwijderd, van naam gewijzigd of tijdelijk niet beschikbaar.",
    "text": "Als je denkt dat dit niet correct is, stuur een bericht naar",
    "title": "Deze pagina is niet meer beschikbaar."
  },
  "administration": {
    "billing": {
      "billing_details": "Facturatiegegevens",
      "bus": "Bus",
      "city": "Gemeente",
      "city_required": "Gemeente is verplicht",
      "company_name": "Bedrijfsnaam",
      "country": "Land",
      "edit_billing_details": "Facturatiegegevens wijzigen",
      "edit_method": "Details bewerken",
      "email_address": "e-mailadres",
      "name_required": "Naam is verplicht",
      "nr": "Nr",
      "nr_required": "Nr is verplicht",
      "postal_code": "Postcode",
      "postal_required": "Postcode is verplicht",
      "save_details": "Facturatiegegevens bewaren",
      "save_method": "Details opslaan",
      "street": "Straat",
      "street_required": "Straat is verplicht",
      "vat": "BTW"
    },
    "invoices": {
      "no_invoice_rights": "U hebt geen rechten om facturen te bekijken. Neem contact op met uw beheerder.",
      "partial_load": "Sommige facturen konden niet worden geladen",
      "downloaddetails": "Detailsamenvatting downloaden",
      "downloaddetailscsv": "Detailsamenvatting downloaden in CSV",
      "actions": "Acties",
      "amount": "Bedrag",
      "columns": {
        "date_range": "Datum",
        "invoice_nr": "Factuur Nr",
        "status": "Status"
      },
      "date": "Datum",
      "download": "Factuur downloaden",
      "downloadattachment": "CDR's downloaden ",
      "due_date": "Vervaldag",
      "invoice_date": "Factuurdatum",
      "invoice_nr": "Factuurnr",
      "invoice_page": "Factuuroverzicht",
      "no_invoices_found": "Geen facturen gevonden",
      "open": "Open",
      "open_amount": "Openstaand bedrag",
      "pay_invoice": "Factuur betalen",
      "payment_status": {
        "open": "Open",
        "paid": "Betaald",
        "pending": "in afwachting"
      },
      "status": "status",
      "total": "Totaal"
    },
    "order": {
      "actions": "acties",
      "activate_sim": "Een simkaart activeren",
      "activate_sim_now": "Sim nu activeren",
      "active": "Actief",
      "approve_installation": "Installatie goedkeuren",
      "available_sims": "Beschikbare simkaarten:",
      "bulk": {
        "address_title": "Leveringsadres",
        "amount": "aantal",
        "amount_label": "aantal",
        "beneficiary": "Begunstigde",
        "btn_place": "Bestelling plaatsen",
        "confirm_message": "U staat op het punt om {amount} SIM-kaarten te bestellen. Weet u het zeker? Gelieve de onderstaande gegevens te controleren:",
        "max_error": "Aantal moet gelijk zijn aan of kleiner zijn dan {max}",
        "min_error": "Aantal moet gelijk zijn aan of groter zijn dan {min}",
        "order_title": "Bulkbestelling SIM-kaarten",
        "success_message": "Bedankt voor uw aanvraag. De simkaarten worden per post bezorgd.",
        "title_confirm": "Bestelling bevestigen"
      },
      "bulk_order_sim": "Bulkbestelling simkaarten",
      "create_ticket": "Ticket aanmaken",
      "customer_nr": "klantnummer",
      "date": "datum",
      "description": "omschrijving",
      "download": "Download",
      "download_pdf": "Pdf downloaden",
      "ended": "stopgezet",
      "filter": "Zoeken ...",
      "id": "ID",
      "included_options": "Inbegrepen opties",
      "installation_date": "Geplande installatiedatum:",
      "invoice_address": "Factuuradres",
      "invoice_customer": "Factuurklant",
      "no_order_found": "Geen bestellingen gevonden",
      "offer": "offerte",
      "offerte": "offerte",
      "order": "Bestelling",
      "order_date": "Besteldatum",
      "order_id": "Bestelnr",
      "order_new_sim": "Nieuwe simkaart(en) bestellen",
      "order_new_subscription": "Nieuw abonnement bestellen",
      "order_overview": "Besteloverzicht",
      "partner": "Partner",
      "pending": "in afwachting",
      "pending_action": "Actie in afwachting",
      "select_sim": "Kies een SIM Kaart nummer uit de lijst hieronder",
      "status": "status",
      "statuses": {
        "awaiting": "Wachten op voltooiing uitvoering",
        "fullfilled": "Voltooid",
        "installation": "Installatie",
        "ordered": "Offerte",
        "processed": "Wachten op goedkeuring",
        "shipped": "Wachten op start uitvoering"
      }
    },
    "usage": "Verbruikdetails"
  },
  "cards": {
    "Download_our_citymesh_connect_app": "Download onze Citymesh Connect App",
    "above_average": "boven gemiddelde",
    "available": "Beschikbaar",
    "below_average": "onder gemiddelde",
    "by_email": "via e-mail",
    "by_post": "via post",
    "call": "Gesprek",
    "called": "gebeld",
    "calling": "Bellen",
    "cease_your_subscription": "Je abonnement stopzetten",
    "change_your_internet": "Je internetverbinding wijzigen",
    "chromecast_smart_tv": "Online tv-kijken met Google Chromecast",
    "company": "Bedrijf",
    "data_mb": "Data (MB)",
    "days_left": "dagen over",
    "details": "Details",
    "disabled": "Uitgeschakeld",
    "enabled": "Ingeschakeld",
    "fiber_content": "Fiber, het netwerk van de toekomst, komt eraan",
    "in_bundle": "Binnen bundel",
    "international": "Internationaal",
    "internet_speed": "Welke snelheid heb ik nodig",
    "invoice_reminders": "Factuurherinneringen",
    "is_due": "te betalen",
    "method": "Details",
    "mobile_data": "Mobiele data",
    "mobile_usage": "Mobiel verbruik",
    "month": "maand",
    "more_info": "Meer info",
    "move_your_internet": "Je internetverbinding verhuizen",
    "nat_eu": "Nationaal + EU",
    "no": "Nee",
    "only_change_request": "Deze gegevens kunnen enkel op aanvraag wijzigen",
    "open_amount": "Openstaand bedrag",
    "out_of_bundle": "Buiten bundel",
    "pay_now": "Nu betalen",
    "payment_services": "Betaaldiensten",
    "peppol": "Peppol",
    "peppol_active": "via Peppol",
    "peppol_id": "Peppol-ID",
    "premium": "Premium",
    "prevent_losing_time": "Internet verliezen, is tijd en geld verliezen",
    "roaming_out": "Roaming (buiten EU)",
    "select_usage_type": "Selecteer een verbruikstype",
    "sent": "verstuurd",
    "sepa_desc": "Betaal je facturen met een domiciliëring, zo kan je nooit te laat betalen",
    "settings": "Instellingen",
    "shortcuts": "Snelkoppelingen",
    "slip_your_bill": "Vergeet je facturen niet",
    "speedtest": "Snelheidstest",
    "stay_in_the_know": "Blijf op de hoogte",
    "tips_tricks": "Tips & Tricks",
    "total_out_of_bundle_cost": "Totale kost buiten bundel",
    "usage": "verbruik",
    "usage_history": "Verbruikshistoriek",
    "usage_statistics": "Verbruiksstatistieken",
    "usage_type": "Verbruikstype",
    "used": "verbruikt",
    "voice_min": "Voice (min)",
    "wifi6_ready": "Ben jij klaar voor WiFi6?!",
    "yes": "Ja"
  },
  "countries": {
    "belgium": "België",
    "france": "Frankrijk",
    "germany": "Duitsland",
    "luxembourg": "Luxemburg",
    "netherlands": "Nederland"
  },
  "customer": {
    "ID": "ID"
  },
  "customer_select": {
    "select_customer": "Selecteer een klant"
  },
  "dashboard": {
    "Welcome back": "Welkom",
    "leaderboard": {
      "cost": "Kosten",
      "name": "Naam",
      "rank": "Ranglijst",
      "title": "Top 5 Gebruikers",
      "usageOrder": {
        "Cost": "Kosten",
        "Volume": "Volume"
      },
      "usageType": {
        "MOBILE_DATA_BELGIUM": "Mobiele Data België",
        "MOBILE_DATA_ROAMING_EU": "Mobiele Data Roaming EU",
        "MOBILE_DATA_ROAMING_ROW": "Mobiele Data Roaming Buitenland",
        "SMS_BELGIUM": "SMS België",
        "SMS_PREMIUM": "Premium SMS",
        "SMS_ROAMING_EU": "SMS Roaming EU",
        "SMS_ROAMING_ROW": "SMS Roaming Buitenland",
        "SMS_TO_INTERNATIONAL": "SMS naar het buitenland",
        "VOICE_BELGIUM": "Bellen België",
        "VOICE_INTERNATIONAL": "Bellen naar het buitenland",
        "VOICE_PREMIUM": "Premium Spraakdienst",
        "VOICE_ROAMING_EU": "Bellen Roaming EU",
        "VOICE_ROAMING_ROW": "Bellen Roaming Buitenland"
      },
      "volume": "Volume"
    },
    "products": {
      "title": "Uw abonnementen of aansluitingen"
    }
  },
  "error": {
    "customer_select_title": "Ongeldig verzoek",
    "unknown_customer_id": "Oeps, we konden dit verzoek niet verwerken. Selecteer een klant.  Jje kan via het menu rechtsboven wisselen tussen klanten.",
    "wrong_customer_id_redirect": "Oeps, we konden dit verzoek niet verwerken."
  },
  "filter": {
    "add_filter": "Filter toevoegen",
    "contains": "bevat",
    "is": "is",
    "is_after": "is na",
    "is_before": "is vóór",
    "is_not": "is niet",
    "range": "periode",
    "status": {
      "1": "In uitvoering",
      "2": "In de wacht gezet",
      "3": "Voltooid",
      "4": "Opvolgen",
      "21": "Te Doen",
      "22": "Klant antwoord nodig",
      "Completed": "Voltooid",
      "Customer reply needed": "Klant antwoord nodig",
      "CustomerReplyNeeded": "Klant antwoord nodig",
      "Follow up": "Opvolgen",
      "FollowUp": "In Opvolging",
      "In progress": "In uitvoering",
      "InProgress": "In Uitvoering",
      "On hold": "In de wacht gezet",
      "OnHold": "In de wacht gezet",
      "Open": "Open",
      "Paid": "Betaald",
      "To do": "Te Doen",
      "ToDo": "Te Doen",
      "open": "Open",
      "paid": "Betaald"
    }
  },
  "global": {
    "activate": "Activeren",
    "active": "Actief",
    "cancel": "annuleren",
    "cancelled": "geannuleerd",
    "click_for_details": "Klik voor details",
    "click_to_hide": "Klik om samen te vouwen",
    "close": "Sluiten",
    "confirm": "Bevestigen",
    "confirm_title": "Weet u het zeker?",
    "connection_error_message": "We kunnen geen verbinding maken met Citymesh.com",
    "connection_error_title": "Geen verbinding",
    "cookie_policy": "Cookie Beleid",
    "day": "dag",
    "deactivate": "Deactiveren",
    "email_required": "E-mailadres verplicht",
    "email_valid": "E-mailadres moet geldig zijn",
    "fetching": "ophalen",
    "general_conditions": "Algemene Voorwaarden",
    "go_to_page": "Ga naar pagina",
    "inactive": "Niet actief",
    "loading": "Laden",
    "month": "maand",
    "no_results": "Geen resultaten",
    "of": "van",
    "ok": "Ok",
    "online": "online",
    "pending": "in afwachting",
    "powered_by": "Powered by",
    "privacy_policy": "Privacy Beleid",
    "required_field": "verplicht veld",
    "results": "weergegeven",
    "retry_connection": "Opnieuw verbinding maken",
    "showing": "Resultaten",
    "invalid_phone_format": "ongeldig telefoonnummer",
    "invalid_email": "ongeldig e-mailadres"
  },
  "language": {
    "French": "Frans",
    "dutch": "Nederlands",
    "english": "Engels"
  },
  "language_selector": {
    "language": "Taal"
  },
  "menu": {
    "404": "404",
    "auth": "Auth",
    "billing": "Billing",
    "buttons": "Knoppen",
    "dashboard": "Dashboard",
    "faq": "FAQ",
    "home": "Home",
    "login": "Aanmelden",
    "payment-methods": "Betalingsmogelijkheden",
    "payments": "Betalingen",
    "preferences": "Account voorkeuren",
    "pricing-plans": "Tariefplannen",
    "projects": "Projecten",
    "recover-password": "Wachtwoord herstellen",
    "recover-password-email": "Emailadres voor wachtwoordherstel",
    "settings": "Toepassingsinstellingen",
    "signup": "Inschrijven",
    "timelines": "Tijdlijnen",
    "users": "Gebruikers"
  },
  "menu_side": {
    "administration": "Administratie",
    "billing": "Facturatie",
    "home": "Home",
    "internet": "Internet",
    "invoices": "Facturen",
    "mind": "Mind",
    "mindinvoices": "Facturen",
    "mobile": "Mobile",
    "orders": "Bestellingen",
    "overview": "Overzicht",
    "products": "Producten",
    "support": "Support",
    "unauthorized": "403",
    "usermanagement": "Gebruikersbeheer",
    "usage": "Verbruik"
  },
  "message": {
    "usage_history": "Verbruikshistoriek"
  },
  "order": {
    "require_sim_select_error": "Geen SIM Kaart geselecteerd"
  },
  "partner": {
    "addresstool": {
      "name": "klanten naam",
      "title": "Partnertools",
      "warning": "De weergegeven snelheden zijn informatief en hebben geen contractuele waarde.",
      "box": "Bus",
      "city": "Stad",
      "expectedfiber": "Verwachte glasvezelsnelheden:",
      "expectedinternet": "Verwachte internetsnelheden:",
      "fiber": "GPON",
      "invalid_request": "Ongeldige aanvraag",
      "internet": "VDSL",
      "linetest": "Lijntest",
      "maxdownload": "Maximale download snelheid:",
      "maxspeed": "Maximale snelheid:",
      "maxupload": "Maximale upload snelheid:",
      "nodata": "Geen gegevens gevonden voor dat adres",
      "technology_not_available": "Sorry, de gevraagde technologie is niet beschikbaar op dit adres. Probeer de Coax- of Fiber-adrescheck.",
      "number": "Nummer",
      "result": "Uw Resultaat",
      "run": "Uitvoeren",
      "street": "Straat",
      "validation": {
        "invalid_city": "Ongeldige stadsnaam",
        "invalid_format": "Ongeldig formaat (gebruik letters of algemene symbolen)",
        "invalid_number": "Ongeldig huisnummer",
        "invalid_zip": "Ongeldig formaat postcode",
        "numeric_only": "Veld mag alleen cijfers bevatten",
        "required": "Veld is verplicht"
      },
      "zipcode": "Postcode",
      "ticket_created": "Ticket {id} is aangemaakt. We zullen binnen 5 dagen contact met u opnemen.",
      "customerName": "Klantnaam"
    },
    "agreements": {
      "title": "Overeenkomsten",
      "upload": "uploaden"
    },
    "commissions": {
      "csv": "csv",
      "pdf": "pdf",
      "title": "Commissieoverzicht"
    },
    "deals": {
      "upload_contract": "Contract uploaden",
      "select_contract": "Contract selecteren",
      "upload": "Uploaden",
      "upload_contract_required": "Selecteer een contract",
      "upload_contract_invalid_type": "Alleen PDF-, PNG-, JPG- en JPEG-bestanden zijn toegestaan",
      "upload_contract_too_large": "Het contract mag niet groter zijn dan 20 MB",
      "upload_contract_size": "{size}/{max} MB",
      "upload_contract_success": "Upload geslaagd",
      "upload_contract_failed": "Upload mislukt",
      "action": "actie",
      "address": "adres",
      "company": "bedrijf",
      "companynr": "Bedrijfsnummer",
      "date": "datum",
      "deal_overview": "Overzicht dealregistratie",
      "deals": "deals",
      "description": "Opmerkingen",
      "email": "e-mail",
      "file": "Bestanden",
      "register": "Registreren",
      "firstname": "Voornaam prospect",
      "lastname": "Achternaam prospect",
      "name": "naam",
      "new_claim": "Nieuwe deal",
      "new_deal": "Deal registreren",
      "phonenumber": "telefoonnummer",
      "reason": "Reden",
      "solution": "Oplossing",
      "solution_other": "Andere oplossing",
      "solution_options": {
        "mobile": "Mobiel",
        "internet": "Internet",
        "ucaas": "UCaaS",
        "fixed_telephony": "Vaste telefonie",
        "other": "Andere"
      },
      "status": "status",
      "statuses": {
        "requested": "Aangevraagd",
        "active": "Actief",
        "pending": "In behandeling",
        "expired": "Verlopen",
        "won": "Gewonnen",
        "rejected": "Afgewezen",
        "cancelled": "Geannuleerd"
      },
      "submit": "nieuwe claim aanmaken",
      "ticket": "ticket",
      "info_succes": "claim succesvol",
      "info_fail": "claim mislukt",
      "dealid": "claim ID",
      "title_success": "Deal succesvol geregistreerd",
      "title_fail": "Dealregistratie mislukt",
      "cancel": "Deal annuleren",
      "cancel?": "Weet je zeker dat je deze deal wilt annuleren?",
      "cancel_success": "Deal succesvol geannuleerd",
      "claimed_until": "geclaimd tot",
      "close": "Sluiten",
      "confirm": "Bevestigen",
      "nodeals": "Geen Deals gevonden"
    },
    "documents": {
      "filter": {
        "contract": "Contract",
        "marketing": "Marketing",
        "pricelist": "Prijslijst",
        "productsheet": "Productblad",
        "none": "Geen",
        "general": "General",
        "other": "Anders"
      },
      "contracttemplates": "Contractsjablonen",
      "documents": "Mijn Documenten",
      "pricelists": "Prijslijsten",
      "productlists": "Productlijsten",
      "submit": "verzenden",
      "title": "Mijn Documenten",
      "file": "Bestand",
      "filetype": "Bestandstype",
      "type": "Type",
      "doctype": {
        "general": "Algemeen",
        "personal": "Persoonlijk"
      },
      "category": "Categorie",
      "date": "Datum",
      "action": "Actie",
      "nodocs": "Geen document gevonden"
    }
  },
  "userManagement":{
    "noUsers": "Geen gebruiker gevonden",
    "userEmail": "E-mail",
    "userFullName": "Volledige naam",
    "userRole": "Rol",
    "userStatus": "Status",
    "userInvitedOn": "Uitgenodigd op",
    "userLastLoggedIn": "Laatst ingelogd",
    "userSplitBilling": "Gesplitste facturatie",
    "actions": "Acties",
    "resendInvite": "Uitnodiging opnieuw versturen",
    "userReinviteSent": "Reinvitation verzonden",
    "userReinviteFailed": "Verzenden van reinvitation mislukt",
    "inviteNewUser": {
      "inviteUserTitle": "Gebruiker uitnodigen",
      "userEmail": "E-mail",
      "userFirstName": "Voornaam",
      "userLastName": "Achternaam",
      "userLanguage": "Taal",
      "userRole": "Rol",
      "inviteUserButton": "Gebruiker uitnodigen",
      "inviteUserSuccess": "Gebruiker succesvol uitgenodigd.",
      "fleetManagerRole": "Fleetbeheerder",
      "simManagerRole": "SIM-beheerder",
      "invoiceManagerRole": "Factuurbeheerder",
      "endUserRole": "Eindgebruiker",
       "missingCredentials": "De authenticatiegegevens ontbreken of zijn ongeldig.",
      "insufficientPermissions": "U hebt geen toestemming om gebruikers aan te maken.",
      "userAlreadyExists": "Er bestaat al een account met dit e-mailadres bij de identity provider.",
      "wrongEmailFormat": "Het e-mailformaat is ongeldig.",
      "unexpectedServerError": "Onverwachte serverfout.",
      "languageEn": "Engels",
      "languageNl": "Nederlands",
      "languageFr": "Frans",
      "editUserTitle": "Gebruiker bewerken",
      "editUserSuccess": "Gebruiker succesvol bijgewerkt.",
      "editUserFailed": "Bijwerken van gebruiker mislukt."
      }
  },
  "payment": {
    "btn_ok": "OK",
    "info_fail": "We hebben je betaling niet ontvangen. Probeer het opnieuw of neem contact op met onze supportafdeling.",
    "info_success": "We hebben je betaling correct ontvangen. Merk op dat het tot 30 minuten kan duren voordat het openstaande bedrag is bijgewerkt.",
    "title_fail": "Betaling mislukt",
    "title_success": "Betaling ontvangen"
  },
  "product": {
    "barrings": {
      "title": "Blokkeringen"
    },
    "mobile": {
      "options": "Opties"
    },
    "usage_warnings": {
      "title": "Gebruikswaarschuwingen"
    }
  },
  "products": {
    "active": "Actief",
    "cancelled": "geannuleerd",
    "filter": "Zoeken ...",
    "inactive": "Inactief",
    "internet": {
      "actions": "acties",
      "address": "adres",
      "available": "Beschikbaar",
      "bus": "Bus",
      "circuit_id": "Circuit id",
      "connection": "verbinding",
      "connection_interrupted": "Als IPv6 geactiveerd wordt, zal je internetverbinding voor enkele seconden onderbroken worden.",
      "details": "Details",
      "down": "Ontvangen",
      "enable_ipv6": "IPv6 activeren",
      "internet_overview": "Internetoverzicht",
      "internet_usage": "Internetverbruik",
      "ip": "IPv4",
      "label": "label",
      "no_internet_found": "Geen internetabonnement gevonden",
      "password": "Wachtwoord",
      "password_modem": "Als je je wachtwoord hier wijzigt, wijzig het ook in de configuratie van je router.",
      "profile": "Profiel",
      "select_subscriber": "Selecteer een abonnee",
      "settings": "Instellingen",
      "start": "Start",
      "status": "status",
      "subscription": "abonnement",
      "type": "Type",
      "up": "Verstuurd",
      "usage_statistics": "Verbruiksstatistieken",
      "username": "Gebruikersnaam"
    },
    "internet_usage": "Internetverbruik",
    "mobile": {
      "esim": "eSIM",
      "psim": "Fysieke SIM",
      "simtype": "SIM type",
      "IMSI_number": "SIM nr",
      "actions": "acties",
      "activate_calls_prem_numbers": "Oproepen naar premium diensten mogelijk",
      "activate_inter_calls": "Internationale oproepen mogelijk",
      "activate_out_of_bundle_sms": "Activeer buitenbundel SMS",
      "activate_prem_numbers": "Activeer oproepen naar premium nummers",
      "activating_option": "We activeren de add-on, dit kan even duren…",
      "activation_date": "Activeringsdatum",
      "activation_success_reference": "Orderreferentie: {orderId}",
      "activation_success_title": "Add-on succesvol geactiveerd",
      "addon_2292": "Op het Citymesh netwerk zal je steeds kunnen genieten van de beste 4G en 5G snelheid.<br />Vandaag kunnen we nog niet het hele land dekken met ons eigen netwerk.<br />Wens je graag 5G ook op het netwerk van onze partner Proximus, <strong>neem dan een 5G optie.</strong><br /><a href=\"https://www.citymesh.be/network-service/\" target=\"_blank\">Meer info over het Citymesh Netwerk.</a>",
      "addon_2294": "Op het Citymesh netwerk zal je steeds kunnen genieten van de beste 4G en 5G snelheid.<br />Vandaag kunnen we nog niet het hele land dekken met ons eigen netwerk.<br />Wens je graag 5G ook op het netwerk van onze partner Proximus, <strong>neem dan een 5G optie.</strong><br /><a href=\"https://www.citymesh.be/network-service/\" target=\"_blank\">Meer info over het Citymesh Netwerk.</a>",
      "addon_2295": "Op het Citymesh netwerk zal je steeds kunnen genieten van de beste 4G en 5G snelheid.<br />Vandaag kunnen we nog niet het hele land dekken met ons eigen netwerk.<br />Wens je graag 5G ook op het netwerk van onze partner Proximus, <strong>neem dan een 5G optie.</strong><br /><a href=\"https://www.citymesh.be/network-service/\" target=\"_blank\">Meer info over het Citymesh Netwerk.</a>",
      "amount": "bedrag",
      "bundle_name": "Bundelnaam",
      "confirm_activate": "Dit activeert dit mobiele abonnement, weet u het zeker?",
      "confirm_activate_option": "Hiermee activeer je de optie {name}, wat een extra bedrag van {price} toevoegt aan je maandelijkse abonnement",
      "confirm_activate_option_title": "Weet je het zeker?",
      "confirm_deactivate": "Dit deactiveert dit mobiele abonnement. Het zal niet meer bruikbaar zijn. Weet u het zeker?",
      "confirm_deactivate_option": "Hiermee deactiveer je de optie {name}, waardoor het bedrag van {price} van je maandelijkse abonnement wordt verwijderd",
      "confirm_sim_swap": "U staat op het punt een simkaartwissel aan te vragen. We sturen u een nieuwe simkaart ter vervanging van uw huidige. Weet u het zeker?",
      "confirm_suspend": "Dit zal dit mobiele abonnement tijdelijk opschorten. Het zal niet bruikbaar zijn. Weet u het zeker?",
      "details": "Details",
      "end_date": "einddatum",
      "fist_warning_sms": "1ste waarschuwing via SMS op",
      "gb_data": "GB DATA",
      "id": "nr",
      "info_out_of_bundle": "U zit momenteel {amount} boven uw limiet. Probeer uw dataverbruik te verlagen.",
      "info_reach_bundle": "Je bent bijna aan je limiet toe. Probeer je dataverbruik te verminderen.",
      "label": "label",
      "limits": "Limieten",
      "minutes": "Minuten",
      "mobile_data": "Mobiele Data",
      "mobile_data_usage": "Verbruik mobiele data",
      "mobile_overview": "Mobiel overzicht",
      "mobile_phone_number": "gsmnummer",
      "msisdn": "MSISDN",
      "no_mobile_subscription": "Geen mobiele abonnementen gevonden",
      "no_subscription_found": "Geen mobiele abonnementen gevonden",
      "out_of_bundle_cost": "Bedrag buiten bundel",
      "phone_from": "Oproep van",
      "price": "Prijs",
      "puk1": "PUK1",
      "puk2": "PUK2",
      "request_failed": "Verzoek mislukt",
      "request_success": "Verzoek succesvol verzonden",
      "temporarily_unavailable": "Tijdelijk niet beschikbaar",
      "no_order_permission": "Je hebt geen rechten om opties te bestellen.",
      "order_in_progress": "Bestelling in behandeling",
      "order_in_progress_blocked": "Er is nog een optiebestelling in behandeling. Je kan een nieuwe optie bestellen zodra die afgerond is.",
      "second_warning_sms": "2de waarschuwing via SMS op",
      "settings": "Instellingen",
      "settings_updated": "Instellingen geüpdated",
      "simnumber": "Sim Nr",
      "sms": "SMS",
      "split_bill_status": "Status van de gedeelde rekening",
      "split_bill_type": "Type gedeelde rekening",
      "start_date": "startdatum",
      "status": "status",
      "subscription": "Abonnement",
      "subscription_name": "abonnementsnaam",
      "suspend": "Opschorten",
      "termination_date": "Terminatiedatum",
      "text_copied": "tekst gekopieerd!",
      "unlimited": "∞",
      "update_settings": "Instellingen updaten",
      "upgrade": "upgrade",
      "usage_warnings": "Verbruikswaarschuwingen"
    },
    "pending": "in afwachting",
    "status": {
      "Created": "Aangemaakt",
      "Ended": "Beëindigd",
      "Fulfilled": "Uitgevoerd",
      "OrderCancelled": "Bestelling geannuleerd",
      "OrderRejected": "Bestelling geweigerd",
      "QuotationRejected": "Offerte geweigerd",
      "Removed": "Verwijderd",
      "WaitingForCleanupApproval": "Wachten op goedkeuring opschoning",
      "WaitingForCleanupCompletion": "Wachten op voltooiing opschoning",
      "WaitingForCleanupInitiation": "Wachten op start opschoning",
      "WaitingForFulfillmentCompletion": "Wachten op voltooiing uitvoering",
      "WaitingForFulfillmentInitiation": "Wachten op start uitvoering",
      "WaitingForOrderApproval": "Wachten op goedkeuring bestelling"
    },
    "status_group": {
      "Active": "Actief",
      "Inactive": "Inactief",
      "Terminated": "Beëindigd"
    },
    "support": {
      "export_all": "Alle tickets",
      "export_filtered": "Gefilterde tickets"
    },
    "terminated": "Beëindigd",
    "usage_details": "Verbruiksdetails"
  },
  "sim_swap": "Vervangen",
  "support": {
    "Field_is_required": "Verplicht veld",
    "You": "Jij",
    "archived": "Gearchiveerd",
    "attachments": "Bijlagen",
    "category": "Categorie",
    "chat_with_us": "Chat met ons!",
    "citymesh_support": "Citymesh Support",
    "closed_on": "Gesloten op",
    "commercial": "Commercieel",
    "content": "Content",
    "create_ticket": "Supportticket openen",
    "created_by": "Gemaakt door",
    "date": "Aanmaakdatum",
    "default": "Default",
    "department": "Afdeling",
    "export": "Exporteer",
    "file_too_large": "Bestand \"{fileName}\" is te groot. Maximum grootte is {maxSize} MB.",
    "filter": "Zoeken",
    "finance": "Boekhouding",
    "helpdesk": "Helpdesk",
    "label": "Label",
    "message": "Bericht",
    "monitor_connections": "Network Monitoring",
    "new_support_ticket": "Nieuw Supportticket",
    "no_product": "Geen",
    "no_support": "Geen supporttickets gevonden",
    "order": "Bestelling",
    "other": "Andere",
    "priorities": {
      "p1": "Dringend (P1)",
      "p2": "Hoog (P2)",
      "p3": "Gemiddeld (P3)",
      "p4": "Laag (P4)"
    },
    "priority": "Prioriteit",
    "priority_number": {
      "1": "P1",
      "2": "P2",
      "3": "P3",
      "4": "P4"
    },
    "product": "Product",
    "resolution": "Resolutie",
    "search_option": "Selecteer een optie",
    "select_column": "Selecteer een kolom",
    "select_operator": "Selecteer een operator",
    "select_option": "Selecteer een optie",
    "select_value": "Selecteer een waarde",
    "send": "Versturen",
    "status": "Status",
    "subject": "Onderwerp",
    "support_ticket": "Supportticket",
    "ticket": {
      "info_fail": "Er is iets fout gelopen bij het aanmaken van je ticket, probeer later opnieuw",
      "info_success": "Je ticket is aangemaakt",
      "p1_contact": "Je hebt een ticket met hoge prioriteit aangemaakt: bel ons op het nummer +32 2 580 91 00 zodat we dit onmiddellijk kunnen opnemen",
      "ticket_number": "ticketnummer",
      "title_fail": "Kan ticket niet aanmaken",
      "title_success": "Ticket aangemaakt",
      "zabbix_link": "Network Monitoring"
    },
    "ticketId": "TicketID",
    "ticket_id": "ticket id",
    "ticket_status": {
      "1": "In behandeling",
      "2": "In wacht",
      "3": "Opgelost",
      "4": "In opvolging",
      "21": "To Do",
      "22": "Wachtend op antwoord",
      "Completed": "Opgelost",
      "Customer reply needed": "Wachtend op antwoord",
      "Follow up": "In opvolging",
      "In progress": "In behandeling",
      "On hold": "In wacht",
      "To do": "To Do"
    },
    "time": {
      "day": "dag",
      "hour": "u",
      "month": "maand",
      "week": "week",
      "year": "jaar"
    },
    "time_opened": "TTR",
    "time_opened_tooltip": "Tijd om op te lossen",
    "times": {
      "day": "dagen",
      "month": "maanden",
      "week": "weken",
      "year": "jaren"
    },
    "total_size_too_large": "Maximaal toegestane gecombineerde bestandsgrootte overschreden",
    "unsupported_file": "Bestand \"{fileName}\" is niet ondersteund",
    "unsupported_file_type": "Bestandsformaat \"{fileName}\" is niet ondersteund. Mogelijke bestandsformaten: {allowedTypes}.",
    "upload file": "Bestand opladen",
    "urgent_question": "Dringende vraag?",
    "view": "Bekijken",
    "write_answer": "antwoord noteren"
  },
  "usage": {
    "cdr_download_failed": "De detailrecords konden niet worden gedownload.",
    "cdr_month_too_old": "Verbruiksgegevens kunnen alleen voor de laatste drie maanden worden geëxporteerd",
    "cdr_no_records": "Er zijn geen detailrecords gevonden voor deze periode.",
    "download_cdr": "Downloaden",
    "page_title": "Verbruikshistoriek",
    "select_product": "Kies een product",
    "select_type": "Kies een verbruikstype"
  },
  "user": {
    "CustomerId": "Klantnummer",
    "ID": "ID",
    "account_settings": "Accountinstellingen",
    "billing": "Facturatie",
    "explore": "Verkennen",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "language": "Taal wijzigen",
    "logout": "Afmelden",
    "profile": "Profiel",
    "projects": "Projecten",
    "settings": "Instellingen",
    "switch_to_fleetportal": "Schakel om naar het fleet portaal"
  },
  "vuestic": {
    "noOptions": "Geen opties beschikbaar",
    "search": "Zoeken"
  }
}
